
import Backbone from 'backbone'
import HitAreaCollection from '../collections/HitAreaCollection'
import LevelCollection from '../collections/LevelCollection'
import LevelModel from '../models/LevelModel'
import UnitCollection from '../collections/UnitCollection'

class MapModel extends Backbone.Model {
  
  defaults() {
    return {
      width: 300,
      height: 300,
      backgroundColor: null,
      viewportWidth: 300,
      viewportHeight: 300,
      x: 0,
      y: 0,
      scale: 0.5,
      translate: [0, 0],
      scaleExtent: [0.1, 8],
      transition: {}
    }
  }

  initialize(attributes, options = {}) {

    // Pass a reference of the MapModel instance down through its children.
    
    options.mapModel = this

    this.set('units', new UnitCollection())
    this.set('hitareas', new HitAreaCollection())
    this.set('levels', new LevelCollection(this.get('elements'), options))
  }

  transition(properties, duration = 350, ease = 'cubic-in-out') {
    this.set('transition', {properties, duration, ease})
    return this
  }
}

export default MapModel
